import Markdown from 'react-markdown'

export default function MarkdownText({
  text,
  custom,
  className,
}: {
  text: string
  custom?: boolean
  className?: string
}) {
  return (
    <div className={`break-words-response inline break-all ${className || ''}`}>
      <Markdown unwrapDisallowed disallowedElements={['p']}>
        {custom ? text.replaceAll('#', '&#35;').replaceAll('>', '&#62;') : text}
      </Markdown>
    </div>
  )
}
